import { IAppState } from '../../store';

export const selectRealtor = (state: IAppState) => state.realtor;
